import TopicMiniGraph from './TopicMiniGraph';

export default TopicMiniGraph;
